import { render, staticRenderFns } from "./AddStoryPage.vue?vue&type=template&id=572d310f&scoped=true&"
import script from "./AddStoryPage.vue?vue&type=script&lang=js&"
export * from "./AddStoryPage.vue?vue&type=script&lang=js&"
import style0 from "./AddStoryPage.vue?vue&type=style&index=0&id=572d310f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572d310f",
  null
  
)

export default component.exports